/*
 * Copyright (c) Nexign, JSC, 2019-2021.
 */
/**
 *
 * @author Mikhail Kokoulin
 * @author Aleksandr Perkhunov
 * @author Yakov Gushchin
 * @version 1.12.0
 * @since 1.0.0
 */
import produce from 'immer';
import { Reducer } from 'redux';

import { LOGOUT_START_SUCCESSFUL } from '../../pages/PageAuth/constants/authConstants';
import { TNotificationActionTypes } from './notificationActions';
import {
    CHANGE_STATUS_NOTIFICATION,
    CLOSE_NOTIFICATION,
    GET_NOTIFICATIONS_FAILED,
    OPEN_NOTIFICATION,
} from './notificationConstants';
import { ENotificationPlace, INotification } from './types/notificationTypes';

export type INotificationState = {
    [key in ENotificationPlace]: {
        currentShowing?: INotification[] | INotification;
        isEnabled: boolean;
        isOpen: boolean;
    }
}

export const initialNotificationState: INotificationState = {
    [ENotificationPlace.accountId]: {
        currentShowing: undefined,
        isEnabled: true,
        isOpen: false,
    },
    [ENotificationPlace.global]: {
        currentShowing: undefined,
        isEnabled: true,
        isOpen: false,
    },
    [ENotificationPlace.subscriberId]: {
        currentShowing: undefined,
        isEnabled: true,
        isOpen: false,
    },
};

const notificationReducer: Reducer<INotificationState, TNotificationActionTypes> =
    (state: INotificationState = initialNotificationState, action: TNotificationActionTypes) =>
        produce(state, (draft) => {
            switch (action.type) {
                case OPEN_NOTIFICATION:
                    draft[action.payload.place].isOpen = true;
                    draft[action.payload.place].currentShowing = action.payload.notification;
                    break;
                case CLOSE_NOTIFICATION:
                    draft[action.payload.place].isOpen = false;
                    draft[action.payload.place].currentShowing = undefined;
                    break;
                case GET_NOTIFICATIONS_FAILED:
                    draft[action.payload.place].currentShowing = undefined;
                    break;
                case CHANGE_STATUS_NOTIFICATION:
                    draft[action.payload.place].isEnabled = action.payload.isEnable;
                    break;
                case LOGOUT_START_SUCCESSFUL:
                    return initialNotificationState;
                default:
                    break;
            }
        });

export default notificationReducer;
